import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationsHelper {

    constructor(
        private translate: TranslateService
    ) {}

    public doTranslations(translations: {[key: string]: string | {[key: string]: string}}, accuKey: string = '') {
        for(const key in translations) {
            const val = translations[key];
            if(typeof val === 'string') {
                translations[key] = this.translate.instant(`${accuKey}.${key}`);
            } else {
                this.doTranslations(val, `${accuKey}.${key}`);
            }
        }
    }

}
